import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { Observable } from 'rxjs/Observable';
import { Country } from '../../../models/country.model';
import { CurrenciesService } from '../../../services/currencies/currencies.service';
import { LanguageService } from '../../../services/language/language.service';
import { CountryService } from './../../../services/country/country.service';

@Component({
  selector: 'app-kv-country-form',
  templateUrl: 'countryForm.html',
  styles: ['label.required:after {top: 0}']
})

export class CountryFormComponent implements OnInit {
  @Output() countryAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() countryUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxCountry: Country;
  addEditForm: FormGroup;
  currencies: Array<any>
  languages: Array<any>

  public invalidSubmit: boolean;

  validators = {
    patternIso: KoncentroValidators.pattern('^[A-Z]*$'),
    integerNotNegative: KoncentroValidators.integerNotNegative
  }

  show = {
    form: false
  }

  model = {
    language: null,
    currency: null
  }

  validation: any;

  constructor(
    private fb: FormBuilder,
    private srvCountry: CountryService,
    private srvCurrency: CurrenciesService,
    private srvLanguage: LanguageService) {
  }

  ngOnInit(): void {

    let Languages = Observable.of(null);
    let Currencies = Observable.of(null);

    if(this.dialogBoxCountry && this.dialogBoxCountry.language_id){
      let searchLanguages = [
        {key: 'id',value: this.dialogBoxCountry.language_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      Languages = this.srvLanguage.list(null,null,searchLanguages);
    }

    if(this.dialogBoxCountry && this.dialogBoxCountry.currency_id){
      let searchCurrencies = [
        {key: 'id',value: this.dialogBoxCountry.currency_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      Currencies = this.srvCurrency.list(null,null,searchCurrencies);
    }


    Observable.zip(
      Languages,
      Currencies,
      this.srvCountry.getFields()
    ).subscribe(([resLanguages, resCurrencies, resValidation]) => {

      this.validation = resValidation;
      this.languages = [];
      this.currencies = [];

      if(resLanguages && resLanguages.data){
        this.languages = resLanguages.data;
        this.model.language = this.languages[0];
      }

      if(resCurrencies && resCurrencies.data){
        this.currencies = resCurrencies.data;
        this.model.currency = this.currencies[0];
      }

      this.show.form = true;

      /*** ordinamento alfabetico lingue ***/
      this.languages.sort(function(a, b){
        if (a.label < b.label) {
           return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
     })


      this.addEditForm = this.fb.group({
        'name': new FormControl(this.dialogBoxCountry.name) || '',
        'currency_id': new FormControl(this.dialogBoxCountry.currency_id) || '',
        'language_id': new FormControl(this.dialogBoxCountry.language_id) || '',
        'iso_code': new FormControl(this.dialogBoxCountry.iso_code) || ''
      });

      this.show.form = true;

   });
  }
  /*** Gestione autocomplete Language */
  filterLanguageSingle(event){
    if(event){
      let search = [
        {key: 'language',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      this.srvLanguage.list(null,null,search).subscribe(res=>{
        this.languages = [];
        if(res && res.data){
          this.languages = res.data;
        }
      })
    }
  }
  onSelectLanguage(event){
    this.addEditForm.get('language_id').setValue(event.id);
  }
  onClearLanguage(){
    this.addEditForm.get('language_id').setValue(null);
    this.model.language = null;
  }
  /*** Gestione autocomplete Currency */
  filterCurrencySingle(event){
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      this.srvCurrency.list(null,null,search).subscribe(res=>{
        this.currencies = [];
        if(res && res.data){
          this.currencies = res.data;
        }
      })
    }
  }
  onSelectCurrency(event){
    this.addEditForm.get('currency_id').setValue(event.id);
  }
  onClearCurrency(){
    this.addEditForm.get('currency_id').setValue(null);
    this.model.currency = null;
  }
  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxCountry, this.addEditForm.value);
    if (newData.id == null) {
      this.countryAdded.emit(newData);
    } else {
      this.countryUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/country/countryForm.component.ts